<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>
          <a-col :span="12">
            <a-form-item label="配置id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['setId', validatorRules.setId]"
                placeholder="请输入配置id"
                :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="配置名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['setName', validatorRules.setName]" placeholder="请输入配置名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['status', validatorRules.status]"
                :trigger-change="true"
                dictCode="data_sync_status"
                placeholder="请选择状态"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头数据库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['sourceCode', validatorRules.sourceCode]"
                :trigger-change="true"
                dictCode="bus_data_sync_data_source,name,code"
                placeholder="请选择源头数据库"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否有序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                @add="OrderorNotAdd"
                v-decorator="['haveSeq', validatorRules.haveSeq]"
                :trigger-change="true"
                dictCode="yn"
                placeholder="请选择是否有序"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '1'">
            <a-form-item label="分组编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['groupNo', validatorRules.groupNo]" placeholder="请输入分组编码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '1'">
            <a-form-item label="组内顺序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['sequence', validatorRules.sequence]"
                placeholder="请输入组内顺序"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-show="haveSeq == '0'">
            <a-form-item label="是否同步全部" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['syncAllFlag', validatorRules.syncAllFlag]"
                :trigger-change="true"
                dictCode="yn"
                placeholder="请选择是否同步全部"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="定时任务" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <m-ore-select :showType="true"
                            showTypeName="jobDesc"
                            showTypeValue="id"
                            v-decorator="['jobId', validatorRules.jobId]"
                            url="/base/busDataSyncBaseSet/getXxlJobList"
                            :asterisk="false"
                            :params="{}"
                            placeholder="请选择定时任务">
              </m-ore-select>
            </a-form-item>
          </a-col>
          <!-- 用于左右对齐 -->
          <a-col :span="12" v-show="haveSeq == '0'" style="opacity: 0;">
            <a-form-item label="是" :labelCol="labelCol" :wrapperCol="wrapperCol">
              1
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataTable', validatorRules.dataTable]"
                placeholder="请输入源头业务表"
                :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetTable', validatorRules.targetTable]"
                placeholder="请输入目标业务表"
                :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表主键" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataKey', validatorRules.dataKey]"
                placeholder="请输入源头业务表主键"
                :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表主键" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetKey', validatorRules.targetKey]"
                placeholder="请输入目标业务表主键"
                :disabled="ifEdit"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="源头业务表字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataField', validatorRules.dataField]"
                placeholder="请输入源头业务表字段"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="目标业务表字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['targetField', validatorRules.targetField]"
                placeholder="请输入目标业务表字段"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导出formid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['expFormid', validatorRules.expFormid]" placeholder="请输入导出formid"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导入formid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['impFormid', validatorRules.impFormid]" placeholder="请输入导入formid"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="过滤条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['dataFilter', validatorRules.dataFilter]" placeholder="请输入过滤条件"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="执行存储过程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['dataProcedure', validatorRules.dataProcedure]"
                placeholder="请输入执行存储过程"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导出前状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['expBeforeStatus', validatorRules.expBeforeStatus]"
                placeholder="请输入导出前状态"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导出到中心状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['expCenterStatus', validatorRules.expCenterStatus]"
                placeholder="请输入导出到中心状态"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导出到所有目标状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['expTargetStatus', validatorRules.expTargetStatus]"
                placeholder="请输入导出到所有目标状态"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="导入的状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['impStatus', validatorRules.impStatus]"
                placeholder="请输入导入的状态"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="目标数据库" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="busDataSyncDocSetTargetTable.loading"
            :columns="busDataSyncDocSetTargetTable.columns"
            :dataSource="busDataSyncDocSetTargetTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true"
          >
          </j-editable-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import MOreSelect from './NAmeMOreSelect.vue'
export default {
  name: 'BusDataSyncDocMainSetModal',
  mixins: [JEditableTableMixin],
  components: {
    JDictSelectTag,MOreSelect
  },
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      labelCol2: {
        span: 3,
      },
      wrapperCol2: {
        span: 20,
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        setId: { rules: [{ required: true, message: '请输入配置id!' }] },
        setName: { rules: [{ required: true, message: '请输入配置名称!' }] },
        sourceCode: { rules: [{ required: true, message: '请输入源头数据库!' }] },
        jobId: { rules: [{ required: true, message: '请选择定时任务!' }] },
        dataTable: { rules: [{ required: true, message: '请输入源头业务表!' }] },
        dataKey: { rules: [{ required: true, message: '请输入源头业务表主键!' }] },
        dataField: { rules: [{ required: true, message: '请输入源头业务表字段!' }] },
        dataFilter: { rules: [] },
        dataProcedure: { rules: [] },
        targetTable: { rules: [{ required: true, message: '请输入目标业务表!' }] },
        targetField: { rules: [{ required: true, message: '请输入目标业务表字段!' }] },
        targetKey: { rules: [{ required: true, message: '请输入目标业务表主键!' }] },
        syncAllFlag: { rules: [] },
        remarks: { rules: [] },
        status: { rules: [{ required: true, message: '请输入状态!' }] },
        expFormid: { rules: [] },
        impFormid: { rules: [] },
        expBeforeStatus: { rules: [{ required: true, message: '请输入状态!' }] },
        expCenterStatus: { rules: [{ required: true, message: '请输入状态!' }] },
        impStatus: { rules: [] },
        expTargetStatus: { rules: [] },
        haveSeq: { rules: [{ required: true, message: '请选择是否有序' }] },
        sequence: { rules: [] },
        groupNo: { rules: [] },
      },
      refKeys: ['busDataSyncDocSetTarget'],
      tableKeys: ['busDataSyncDocSetTarget'],
      activeKey: 'busDataSyncDocSetTarget',
      // 目标数据库
      busDataSyncDocSetTargetTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '目标数据库',
            key: 'targetCode',
            // slotName: 'targetCode',
            // type: FormTypes.slot,
            // width: '200px',
            type: FormTypes.select,
            dictCode: 'bus_data_sync_data_source,name,code',
            placeholder: '请输入${title}',
            validateRules: [{ required: true, message: '${title}不能为空' }],
          },
        ],
      },
      url: {
        add: '/datadocsync.base/busDataSyncDocMainSet/add',
        edit: '/datadocsync.base/busDataSyncDocMainSet/edit',
        busDataSyncDocSetTarget: {
          list: '/datadocsync.base/busDataSyncDocMainSet/queryBusDataSyncDocSetTargetByMainId',
        },
      },
      haveSeq: '' //是否有序
    }
  },
  computed: {
    ifEdit() {
      return !!this.model.id
    },
  },
  mounted() {
  },
  methods: {
    OrderorNotAdd(val) {
      this.haveSeq = val
    },
    /** 确定按钮点击事件 */
    handleOk() {
      console.log('6654');
      /** 触发表单验证 */
      this.getAllTable()
        .then(tables => {
          /** 一次性验证主表和所有的次表 */
          return validateFormAndTables(this.form, tables)
        })
        .then(allValues => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          let formData = this.classifyIntoFormData(allValues)
          // 增加是否有序判断
          if (formData.haveSeq == '1') {
            formData.syncAllFlag = null;
          } else if (formData.haveSeq == '0') {
            formData.sequence = null
            formData.groupNo = null
          }
          // 发起请求
          return this.request(formData)
        })
        .catch(e => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
          } else {
            console.error(e)
          }
        })
    },
    getAllTable() {
      let values = this.tableKeys.map((key) => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(
        this.model,
        'setId',
        'setName',
        'jobId',
        'sourceCode',
        'dataTable',
        'dataKey',
        'dataField',
        'dataFilter',
        'dataProcedure',
        'targetTable',
        'targetField',
        'targetKey',
        'syncAllFlag',
        'remarks',
        'status',
        'expFormid',
        'impFormid',
        'expBeforeStatus',
        'expCenterStatus',
        'impStatus',
        'expTargetStatus',
        'haveSeq',
        'sequence',
        'groupNo'
      )
      this.OrderorNotAdd(this.model.haveSeq)
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      // 加载子表数据
      if (this.model.setId) {
        let params = { setId: this.model.setId }
        this.requestSubTableData(this.url.busDataSyncDocSetTarget.list, params, this.busDataSyncDocSetTargetTable)
      }
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)

      return {
        ...main, // 展开
        busDataSyncDocSetTargetList: allValues.tablesValue[0].values,
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'setId',
          'setName',
          'jobId',
          'sourceCode',
          'dataTable',
          'dataKey',
          'dataField',
          'dataFilter',
          'dataProcedure',
          'targetTable',
          'targetField',
          'targetKey',
          'syncAllFlag',
          'remarks',
          'status',
          'expFormid',
          'impFormid',
          'expBeforeStatus',
          'expCenterStatus',
          'impStatus',
          'expTargetStatus',
          'haveSeq',
          'sequence',
          'groupNo'
        )
      )
    },
  },
}
</script>

<style scoped></style>
<style lang="less" scoped>
.ant-form-item{
  margin-bottom: 10px !important;
}
</style>